import { FrameData } from '../../types';
import { BeatPulse } from '../../utils/audioUtils';
import { hsl } from '../../utils/colorUtils';
import { LayerRenderer } from './LayerRenderer';

export class FrequencyBarsRenderer implements LayerRenderer {
  private beatPulse = new BeatPulse(0.93);

  init(): void {}

  render(
    ctx: CanvasRenderingContext2D,
    frame: FrameData,
    settings: Record<string, number>,
    width: number,
    height: number,
  ): void {
    const { frequencyData, isBeat, beatIntensity } = frame;
    const barCount = Math.round(settings.barCount ?? 64);
    const gap = settings.gap ?? 2;
    const colorHue = settings.colorHue ?? 0;
    const sensitivity = settings.sensitivity ?? 1.2;

    this.beatPulse.update(isBeat, beatIntensity);

    const totalGaps = (barCount - 1) * gap;
    const barWidth = Math.max(1, (width - totalGaps) / barCount);
    const usableBins = Math.floor(frequencyData.length * 0.6);
    const binsPerBar = usableBins / barCount;

    for (let i = 0; i < barCount; i++) {
      const startBin = Math.floor(i * binsPerBar);
      const endBin = Math.floor((i + 1) * binsPerBar);
      let sum = 0;
      for (let b = startBin; b < endBin; b++) sum += frequencyData[b];
      const amplitude = (sum / (endBin - startBin) / 255) * sensitivity;
      const barHeight = Math.min(height, amplitude * height);

      const hue = (i / barCount) * 240 + colorHue;
      const lightness = 45 + this.beatPulse.value * 25;
      ctx.fillStyle = hsl(hue, 80, lightness);

      const x = i * (barWidth + gap);
      const y = height - barHeight;
      ctx.fillRect(x, y, barWidth, barHeight);

      // Peak hold line
      ctx.fillStyle = hsl(hue, 90, 75, 0.8);
      ctx.fillRect(x, y, barWidth, 2);
    }
  }

  resize(): void {}
  destroy(): void {}
}
